import type { RequiredGeneric } from '@pba/react-utils';
import { PasswordInput } from 'ui';
import { useNewPasswordRules } from '../hooks';

export type NewPasswordFormContentValues = {
  password: string;
};

const NewPasswordFormContent = <T extends NewPasswordFormContentValues = never>(_: RequiredGeneric<T>) => {
  const newPasswordRules = useNewPasswordRules();

  return (
    <PasswordInput
      item={{
        label: 'New password',
        name: 'password',
        rules: newPasswordRules,
      }}
      showValidation
    />
  );
};

export default NewPasswordFormContent;
